import React, { createContext, useContext, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

const MediaQueryContext = createContext();

export const MediaQueryProvider = ({ children }) => {
  const [wpNumber, setWpNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [contactUSData, setContactUSData] = useState('');
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.down('xl'));

  return (
    <MediaQueryContext.Provider value={{ isSmallScreen, isMediumScreen, isLargeScreen, isExtraLargeScreen, wpNumber, setWpNumber, contactUSData, setContactUSData, loading, setLoading }}>
      {children}
    </MediaQueryContext.Provider>
  );
};

export const useMediaQueries = () => {
  return useContext(MediaQueryContext);
};